import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { PageApi, PageApiImpl } from '@/infrastructure/api-functions/page-api';
import { PageModel, PageModelImpl } from '@/services/page-model';
import { PageService, PageServiceImpl } from '@/services/page-service';

export const pageModule = new ContainerModule((bind) => {
    bind(PageApi).to(PageApiImpl);
    bind(PageModel).to(PageModelImpl);
    bind(PageService).to(PageServiceImpl);
});
